//

export const CAMPUSVIRTUAL_SET_IDCAMPUS = "campusvirtual/SETIDCAMPUS"
export const CAMPUSVIRTUAL_SET_LISTACAMPI = "campusvirtual/SETLISTACAMPI"
export const CAMPUSVIRTUAL_SET_LISTACONFIGURACIONES =
  "campusvirtual/SETLISTACONFIGURACIONES"
export const CAMPUSVIRTUAL_SET_AUTHENTICATEDUSER =
  "campusvirtual/SETAUTHENTICATEDUSER"
export const CAMPUSVIRTUAL_UNSET_AUTHENTICATEDUSER =
  "campusvirtual/UNSETAUTHENTICATEDUSER"

export const CAMPUSVIRTUAL_WAIT_FOR_PROPERTY_TO_CHANGE =
  "campusvirtual/WAIT_FOR_PROPERTY_TO_CHANGE"

export const CAMPUSVIRTUAL_POST_SENDTEMPLATE = "campusvirtual/SENDTEMPLATE"
export const CAMPUSVIRTUAL_POST_SENDTEMPLATE_SUCCESS =
  "campusvirtual/SENDTEMPLATESUCCESS"
export const CAMPUSVIRTUAL_POST_SENDTEMPLATE_FAIL =
  "campusvirtual/SENDTEMPLATEFAIL"

export const CAMPUSVIRTUAL_GET_DATASEGMENTOS = "campusvirtual/DATASEGMENTOS"
export const CAMPUSVIRTUAL_GET_DATASEGMENTOS_SUCCESS =
  "campusvirtual/DATASEGMENTOSSUCCESS"
export const CAMPUSVIRTUAL_GET_DATASEGMENTOS_FAIL =
  "campusvirtual/DATASEGMENTOSFAIL"

export const CAMPUSVIRTUAL_GET_ALUMNOSSEGMENTADOS =
  "campusvirtual/ALUMNOSSEGMENTADOS"
export const CAMPUSVIRTUAL_GET_ALUMNOSSEGMENTADOS_SUCCESS =
  "campusvirtual/ALUMNOSSEGMENTADOSSUCCESS"
export const CAMPUSVIRTUAL_GET_ALUMNOSSEGMENTADOS_FAIL =
  "campusvirtual/ALUMNOSSEGMENTADOSFAIL"

export const CAMPUSVIRTUAL_GET_INGRESOSEGRESOS = "campusvirtual/INGRESOSEGRESOS"
export const CAMPUSVIRTUAL_GET_INGRESOSEGRESOS_SUCCESS =
  "campusvirtual/INGRESOSEGRESOSSUCCESS"
export const CAMPUSVIRTUAL_GET_INGRESOSEGRESOS_FAIL =
  "campusvirtual/INGRESOSEGRESOSFAIL"

export const CAMPUSVIRTUAL_LOGOUT = "campusvirtual/LOGOUT"

export const CAMPUSVIRTUAL_GET_CARTERA = "campusvirtual/CARTERA"
export const CAMPUSVIRTUAL_GET_CARTERA_SUCCESS = "campusvirtual/CARTERASUCCESS"
export const CAMPUSVIRTUAL_GET_CARTERA_FAIL = "campusvirtual/CARTERAFAIL"

export const CAMPUSVIRTUAL_GET_CARTERACOMPARATIVA =
  "campusvirtual/CARTERACOMPARATIVA"
export const CAMPUSVIRTUAL_GET_CARTERACOMPARATIVA_SUCCESS =
  "campusvirtual/CARTERACOMPARATIVASUCCESS"
export const CAMPUSVIRTUAL_GET_CARTERACOMPARATIVA_FAIL =
  "campusvirtual/CARTERACOMPARATIVAFAIL"

export const CAMPUSVIRTUAL_GET_ULTIMOSRECIBOS = "campusvirtual/ULTIMOSRECIBOS"
export const CAMPUSVIRTUAL_GET_ULTIMOSRECIBOS_SUCCESS =
  "campusvirtual/ULTIMOSRECIBOSSUCCESS"
export const CAMPUSVIRTUAL_GET_ULTIMOSRECIBOS_FAIL =
  "campusvirtual/ULTIMOSRECIBOSFAIL"

export const CAMPUSVIRTUAL_GET_CAMPUS = "campusvirtual/CAMPUS"
export const CAMPUSVIRTUAL_GET_CAMPUS_SUCCESS = "campusvirtual/CAMPUSSUCCESS"
export const CAMPUSVIRTUAL_GET_CAMPUS_FAIL = "campusvirtual/CAMPUSFAIL"

export const CAMPUSVIRTUAL_GET_CARRERAS = "campusvirtual/CARRERAS"
export const CAMPUSVIRTUAL_GET_CARRERAS_SUCCESS =
  "campusvirtual/CARRERASSUCCESS"
export const CAMPUSVIRTUAL_GET_CARRERAS_FAIL = "campusvirtual/CARRERASFAIL"

export const CAMPUSVIRTUAL_GET_PLANES = "campusvirtual/PLANES"
export const CAMPUSVIRTUAL_GET_PLANES_SUCCESS = "campusvirtual/PLANESSUCCESS"
export const CAMPUSVIRTUAL_GET_PLANES_FAIL = "campusvirtual/PLANESFAIL"

export const CAMPUSVIRTUAL_GET_STATUS = "campusvirtual/STATUS"
export const CAMPUSVIRTUAL_GET_STATUS_SUCCESS = "campusvirtual/STATUSSUCCESS"
export const CAMPUSVIRTUAL_GET_STATUS_FAIL = "campusvirtual/STATUSFAIL"

export const CAMPUSVIRTUAL_GET_CONFIGURACION = "campusvirtual/CONFIGURACION"
export const CAMPUSVIRTUAL_GET_CONFIGURACION_SUCCESS =
  "campusvirtual/CONFIGURACIONSUCCESS"
export const CAMPUSVIRTUAL_GET_CONFIGURACION_FAIL =
  "campusvirtual/CONFIGURACIONFAIL"

export const CAMPUSVIRTUAL_GET_RESUMENPUNTUALIDAD =
  "campusvirtual/RESUMENPUNTUALIDAD"
export const CAMPUSVIRTUAL_GET_RESUMENPUNTUALIDAD_SUCCESS =
  "campusvirtual/RESUMENPUNTUALIDADSUCCESS"
export const CAMPUSVIRTUAL_GET_RESUMENPUNTUALIDAD_FAIL =
  "campusvirtual/RESUMENPUNTUALIDADFAIL"

export const CAMPUSVIRTUAL_GET_TURNOS = "campusvirtual/TURNOS"
export const CAMPUSVIRTUAL_GET_TURNOS_SUCCESS = "campusvirtual/TURNOSSUCCESS"
export const CAMPUSVIRTUAL_GET_TURNOS_FAIL = "campusvirtual/TURNOSFAIL"

export const CAMPUSVIRTUAL_GET_TRAYECTORIAS = "campusvirtual/TRAYECTORIAS"
export const CAMPUSVIRTUAL_GET_TRAYECTORIAS_SUCCESS =
  "campusvirtual/TRAYECTORIASSUCCESS"
export const CAMPUSVIRTUAL_GET_TRAYECTORIAS_FAIL =
  "campusvirtual/TRAYECTORIASFAIL"

export const CAMPUSVIRTUAL_SET_MESSAGE_SUCCESS =
  "campusvirtual/SET_MESSAGE_SUCCESS"
export const CAMPUSVIRTUAL_UNSET_MESSAGE_SUCCESS =
  "campusvirtual/UNSET_MESSAGE_SUCCESS"

export const CAMPUSVIRTUAL_POST_SENDLINKPAGOEMAIL =
  "campusvirtual/SENDLINKPAGOEMAIL"
export const CAMPUSVIRTUAL_POST_SENDLINKPAGOEMAIL_SUCCESS =
  "campusvirtual/SENDLINKPAGOEMAILSUCCESS"
export const CAMPUSVIRTUAL_POST_SENDLINKPAGOEMAIL_FAIL =
  "campusvirtual/SENDLINKPAGOEMAILFAIL"
